<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">
          {{ adminText('organizationAll.update_tag_67374cbd', 'Update Tag') }}
        </h1>
        <span class="material-icons" @click="$emit(&quot;close&quot;)"> close </span>
      </div>
      <text-field v-model.trim="form.name" :label="adminText('organizationAll.tag_name_df66a26c', 'Tag Name*')" type="text" />
      <div class="buttons">
        <main-button
          class="delete-button"
          color="error"
          flat
          :text="adminText('organizationAll.delete_d6f56360', 'DELETE')"
          @click="$emit('delete', form.id)"
        />
        <div class="buttons-right">
          <main-button
            class="update-btn"
            :text="adminText('organizationAll.update_52c6c181', 'UPDATE')"
            @click="$emit('update', form)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

export default {
  mixins: [OrganizationLocalization],
  name: 'action-modal',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
}
.buttons {
  display: flex;
  align-items: center;
}
.buttons-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close{
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.description{
  margin-top: 0.75rem
}
.material-icons{
  cursor: pointer;
}
</style>
